@if (operation) {
<tec-collapse [title]="`WORKFLOWS.FORM.OPERATIONS.${operation.type}` | translate" [badge]="index.toString()">
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath()"
        titleKey="WORKFLOWS.CURL_MODAL.TITLE_OPERATION"
    />
    <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_REDIRECT' | translate">
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_OK' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_OK_DESCRIPTION' | translate">
            @if (operation.config.redirect) {
                <tec-link [label]="operation.config.redirect" [href]="operation.config.redirect" target="_blank" />
            } @else {
                {{ 'WORKFLOWS.FORM.OPERATIONS.FINISH_REDIRECT_EMPTY' | translate }}
            }
        </tec-info-group>
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_KO' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_KO_DESCRIPTION' | translate">
            @if (operation.config.redirect_ko) {
                <tec-link [label]="operation.config.redirect_ko" [href]="operation.config.redirect_ko" target="_blank" />
            } @else {
                {{ 'WORKFLOWS.FORM.OPERATIONS.FINISH_REDIRECT_EMPTY' | translate }}
            }
        </tec-info-group>
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CANCELLED' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CANCELLED_DESCRIPTION' | translate">
            @if (operation.config.redirect_cancelled) {
                <tec-link [label]="operation.config.redirect_cancelled" [href]="operation.config.redirect_cancelled" target="_blank" />
            } @else {
                {{ 'WORKFLOWS.FORM.OPERATIONS.FINISH_REDIRECT_EMPTY' | translate }}
            }
        </tec-info-group>
    </tec-tile>
    <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK' | translate">
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_OK' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_OK_DESCRIPTION' | translate">
            @if (operation.config.callback) {
                <tec-link [label]="operation.config.callback" [href]="operation.config.callback" target="_blank" />
            } @else {
                {{ 'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_EMPTY' | translate }}
            }
        </tec-info-group>
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_KO' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_KO_DESCRIPTION' | translate">
            @if (operation.config.callback_ko) {
                <tec-link [label]="operation.config.callback_ko" [href]="operation.config.callback_ko" target="_blank" />
            } @else {
                {{ 'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_EMPTY' | translate }}
            }
        </tec-info-group>
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_CANCELLED' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_CANCELLED_DESCRIPTION' | translate">
            @if (operation.config.callback_cancelled) {
                <tec-link [label]="operation.config.callback_cancelled" [href]="operation.config.callback_cancelled" target="_blank" />
            } @else {
                {{ 'WORKFLOWS.FORM.OPERATIONS.FINISH_CALLBACK_EMPTY' | translate }}
            }
        </tec-info-group>
    </tec-tile>
</tec-collapse>
}
